import React, { useState, useEffect, Fragment } from "react";
import { CSVReader } from "react-papaparse";
import { connect } from "react-redux";
import CreatableSelect from "react-select/lib/Creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Button, Toastr } from "../../../revvComponents";
import { FieldsSetting } from "../../../actions";
import { FIELDS, DATA_PLAYFIELD } from "../../../constants";
import FieldsPool from "./FieldsPool";
import ChangingObjectConfirmationPopup from "./ChangingObjectConfirmationPopup";
import { FieldsSettingsUtils, GlobalUtils } from "../../../utils";
import CreateTriggerPopup from "./CreateTriggerPopup";

const {
  updateCurrentSelectedObject,
  nukeSyncDataSourceFlags,
  setCSVData,
  nukeCSVData,
  updateTriggerAction,
  getTriggerDetailsAction,
} = FieldsSetting;
const { checkEmptyMapping } = FieldsSettingsUtils;
const { copyToClipBoard } = GlobalUtils;
const { CRM_INTEGRATIONS_LOGOS } = DATA_PLAYFIELD;

const FieldsMapper = ({
  dsObjects,
  sourceObjSchema,
  dataSourceSelected,
  currentSelectedObject,
  updateCurrObj,
  initFieldsMappingData,
  getTriggers,
  objectFieldsMapping,
  syncDataSource,
  nukeDataSource,
  searchInput,
  updateSearchInput,
  filterState,
  updateFilterState,
  showMenuType,
  updateCSVData,
  nukeCSV,
  showCSVFields,
  toggleOnShowCSVFields,
  toggleOffShowCSVFields,
  csvData,
  triggerDetails,
  updateTrigger,
  templateId,
  triggerPackageUrl,
  cardValue,
}) => {
  const [showChangeObjectConformation, handleSFObjectUpdate] = useState(false);
  const [showCreateTriggerPopup, handleCreateTriggerPopup] = useState(false);
  const [updatedObject, updateDsObj] = useState({});
  const [csvFields, updateCSVFields] = useState([]);
  const [showActiveTriger, handleEnableDisableTrigger] = useState(false);
  const [showTriggerDetails, handleShowTriggerDetails] = useState(false);

  const _checkTriggerAvailability = trigger => {
    handleEnableDisableTrigger(trigger.is_active);
  };
  useEffect(() => {
    if (
      !(dataSourceSelected && currentSelectedObject) &&
      dataSourceSelected !== "csv"
    ) {
      initFieldsMappingData(dataSourceSelected);
      getTriggers(templateId);
    }
    if (
      Object.keys(triggerDetails).length > 0 &&
      triggerDetails[currentSelectedObject]
    ) {
      _checkTriggerAvailability(triggerDetails[currentSelectedObject]);
    }
  }, [
    initFieldsMappingData,
    dataSourceSelected,
    currentSelectedObject,
    getTriggers,
    templateId,
    triggerDetails,
  ]);

  const currObj = dsObjects.find(obj => obj.name === currentSelectedObject);
  if (!currObj && dataSourceSelected !== "csv") {
    return null;
  }

  const _handleSFObjectChange = dsObject => {
    if (currObj !== dsObject) {
      updateFilterState({ label: "All", value: "All" });
      updateSearchInput("");
      const unMappedIds = checkEmptyMapping(objectFieldsMapping);
      if (unMappedIds.length > 0) {
        handleSFObjectUpdate(true);
        updateDsObj(dsObject);
      } else {
        updateCurrObj(dsObject.name);
      }
      if (syncDataSource && syncDataSource.dataSource) {
        nukeDataSource();
      }
    }
  };

  const _tansformCSVData = (data, file) => {
    const fieldsData = [];
    nukeCSV();
    updateCSVFields([]);
    toggleOffShowCSVFields();
    nukeDataSource();
    data.forEach(field => fieldsData.push(field.data));
    const headerFields = fieldsData[0];
    const fieldDataMapping = [];
    for (let i = 1; i < fieldsData.length; i++) {
      if (fieldsData[i].length === headerFields.length) {
        const rowData = {};
        for (let j = 0; j < headerFields.length; j++) {
          rowData[headerFields[j]] = fieldsData[[i]][j];
        }
        fieldDataMapping.push(rowData);
      }
    }
    const updatedFields = [];
    headerFields.forEach(field => {
      const fieldObj = {
        field_type: "string",
        label: field,
        name: field,
        reference_to: null,
        relationship_name: "",
        type: "string",
      };
      updatedFields.push(fieldObj);
    });
    updateCSVFields(updatedFields);
    updateCSVData({
      fields: updatedFields,
      fieldsData: fieldDataMapping,
      originalFile: { name: file.name, type: file.type },
    });
  };

  const _closePopup = () => {
    handleSFObjectUpdate(false);
  };

  const _createTriggerPopup = () => {
    handleCreateTriggerPopup(true);
  };

  const _closeCreateTiggerPopup = () => {
    handleCreateTriggerPopup(false);
  };

  const _onCopyBtnClick = url => {
    if (copyToClipBoard(url)) {
      Toastr.showToastr({
        type: "success",
        message: "Copied Successfully",
        timeout: 3000,
      });
    } else {
      Toastr.showToastr({
        type: "failure",
        message: "Error while copying!...",
        timeout: 3000,
      });
    }
  };

  const _disableTrigger = () => {
    handleEnableDisableTrigger(!showActiveTriger);
    const updateTriggerPayload = {
      is_active: !showActiveTriger,
    };
    updateTrigger(
      updateTriggerPayload,
      triggerDetails[currentSelectedObject].trigger_id,
    );
  };
  const dataSource = FIELDS.DATA_SOURCES.find(
    source => source.name === dataSourceSelected,
  );

  if (showChangeObjectConformation) {
    return (
      <ChangingObjectConfirmationPopup
        closePopup={_closePopup}
        updateCurrObj={updateCurrObj}
        dsObject={updatedObject}
      />
    );
  }
  if (showCreateTriggerPopup) {
    return (
      <CreateTriggerPopup
        closePopup={_closeCreateTiggerPopup}
        updateCurrObj={updateCurrObj}
        dsObject={updatedObject}
        triggerDetails={triggerDetails}
      />
    );
  }
  let filterOptions = [];
  if (
    currentSelectedObject &&
    sourceObjSchema &&
    sourceObjSchema[currentSelectedObject]
  ) {
    filterOptions = Object.keys(sourceObjSchema[currentSelectedObject]);
    if (cardValue === "TABLE") {
      filterOptions =
        sourceObjSchema[currentSelectedObject].MultiReference &&
        Array.isArray(filterOptions) &&
        filterOptions.filter(
          op =>
            sourceObjSchema[currentSelectedObject].MultiReference.includes(
              op,
            ) && op !== "MultiReference",
        );
    } else if (cardValue === "FORM") {
      filterOptions =
        Array.isArray(filterOptions) &&
        filterOptions.filter(op => op !== "MultiReference");
    } else {
      filterOptions =
        sourceObjSchema[currentSelectedObject].MultiReference &&
        Array.isArray(filterOptions) &&
        filterOptions.filter(
          op =>
            !sourceObjSchema[currentSelectedObject].MultiReference.includes(
              op,
            ) && op !== "MultiReference",
        );
    }
  }
  const _showToasterMsg = value => {
    Toastr.showToastr({
      type: "failure",
      message: value,
      timeout: 3000,
    });
  };
  const filterStateObj = { value: filterState, label: filterState };
  const _searchRelatedObjects = () => (
    <div className="sf-search-section">
      <div className="templateheader-search">
        <FontAwesomeIcon
          icon={["far", "search"]}
          className="templateheader-searchicon"
        />
        <Input
          data-test="template-search-input"
          className="templateheader-input"
          placeholder="Search Fields"
          value={searchInput}
          // onFocus={() => this.toggleDropdown(true)}
          onChange={updateSearchInput}
          // onKeyDown={this.handleKeyDown}
          data-id="template-search"
        />
      </div>
      <div className="sf-related-obj-dropdown">
        {currentSelectedObject &&
          sourceObjSchema &&
          sourceObjSchema[currentSelectedObject] &&
          Array.isArray(filterOptions) && (
            <CreatableSelect
              isSearchable
              style={{
                height: "40px",
              }}
              isDisabled={false}
              options={filterOptions.map(t => ({ value: t, label: t }))}
              value={filterStateObj}
              onChange={updateFilterState}
              data-test="sf-objects-select"
              isValidNewOption={() => false}
            />
          )}
      </div>
    </div>
  );
  const fieldMappingCount = objectFieldsMapping
    ? objectFieldsMapping.length
    : 0;
  const disableCreateAutomationBtn =
    fieldMappingCount === 0 || !currentSelectedObject;
  return (
    <div className="col-md-12 sfi-mapper-left-section">
      <div className="sf-mapper-title">
        <img
          src={CRM_INTEGRATIONS_LOGOS[dataSource.label]}
          alt="dataSource.label"
          height="30"
          width="50"
        />{" "}
        {dataSourceSelected === "csv"
          ? "Upload CSV to map fields"
          : `Available ${dataSource.label} Objects`}
      </div>
      {dataSourceSelected === "csv" && (
        <div className="csv-input">
          <div>Upload Sheet</div>
          {csvData && !csvData.originalFile && (
            // Upload new CSV file
            <CSVReader
              onDrop={_tansformCSVData}
              onError={() => console.debug("ON ERROR")}
              addRemoveButton
              onRemoveFile={() => {
                nukeCSV();
                toggleOffShowCSVFields();
              }}
              style={{
                dropArea: {
                  borderRadius: 3,
                  borderWidth: "1px",
                  height: "30px",
                },

                dropFile: {
                  display: "none",
                },
              }}>
              <span>
                <i>
                  <FontAwesomeIcon
                    icon={["fas", "file-spreadsheet"]}
                    className="google-sheet-icon"
                  />
                </i>{" "}
                Select and drop a sheet here
              </span>
            </CSVReader>
          )}
          {csvData && csvData.originalFile && (
            <div className="uploaded-csv-wrapper">
              <div>
                <i>
                  <FontAwesomeIcon
                    icon={["fas", "file-spreadsheet"]}
                    className="google-sheet-icon"
                  />
                </i>{" "}
                {csvData.originalFile.name}
              </div>
              <div className="edit-csv">
                {/* Update CSV */}
                <CSVReader
                  onDrop={_tansformCSVData}
                  onError={() => console.debug("ON ERROR")}
                  addRemoveButton
                  onRemoveFile={() => {
                    nukeCSV();
                    toggleOffShowCSVFields();
                    nukeDataSource();
                  }}
                  style={{
                    dropArea: {
                      border: "none",
                      height: "30px",
                    },

                    dropFile: {
                      display: "none",
                    },
                  }}>
                  <span>
                    <FontAwesomeIcon icon={["far", "edit"]} />
                  </span>
                </CSVReader>
              </div>
            </div>
          )}

          <div className="csv-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="data-studio-fetch-popup-cancle-btn"
              onClick={() => {
                toggleOffShowCSVFields();
                updateCSVFields([]);
                nukeCSV();
                nukeDataSource();
              }}>
              Cancel
            </Button>
            <Button
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="data-studio-fetch-popup-submit-btn"
              disabled={csvFields.length === 0 && !csvData.originalFile}
              onClick={() => {
                toggleOnShowCSVFields();
                // updateCurrObj(currentSelectedObject);
              }}>
              Sync fields
            </Button>
          </div>
        </div>
      )}
      {dataSourceSelected === "csv" && showCSVFields && (
        <div className="sf-mapper-left-container">
          <Fragment>
            <FieldsPool
              searchInput={searchInput}
              filterState={""}
              currentObject={""}
              currentDataSource={dataSourceSelected}
              showMenuType={"FORM"}
              showCSVFields={showCSVFields}
              searchRelatedObjects={_searchRelatedObjects}
            />
          </Fragment>
        </div>
      )}
      {dataSourceSelected !== "csv" && (
        <div className="sf-filter-container">
          {/* Select sf object */}
          <div className="sf-filter-sf-select">
            <div className="assigned-sf-field-head">
              {`Select ${dataSource.label} object`}
            </div>
            <div className="assigned-sf-field-select">
              {Array.isArray(dsObjects) && (
                <CreatableSelect
                  isSearchable
                  style={{
                    height: "40px",
                  }}
                  isDisabled={false}
                  options={dsObjects}
                  value={currObj}
                  onChange={_handleSFObjectChange}
                  data-test="sf-objects-select"
                  isValidNewOption={() => false}
                />
              )}
            </div>
          </div>
          <div>
            {triggerDetails &&
            triggerDetails[currentSelectedObject] &&
            triggerDetails[currentSelectedObject].trigger_id ? (
              <FontAwesomeIcon
                icon={["far", "link"]}
                className="trigger-link-icon"
                color="#FF0078"
              />
            ) : (
              <FontAwesomeIcon
                icon={["far", "link"]}
                className="trigger-link-icon"
              />
            )}
          </div>
          <div className="trigger-btn">
            {triggerDetails &&
            triggerDetails[currentSelectedObject] &&
            triggerDetails[currentSelectedObject].trigger_id ? (
              <Button
                type="three"
                data-test="add-new-field-btn"
                className={`${
                  showActiveTriger
                    ? "create-trigger-btn"
                    : "create-trigger-btn-disabled"
                }`}
                // disabled={!showActiveTriger}
                onClick={
                  showActiveTriger
                    ? () => _createTriggerPopup()
                    : () => _showToasterMsg(" Enable the automation to edit ")
                }>
                <FontAwesomeIcon icon={["far", "edit"]} className="" />
                &nbsp; Edit automation
              </Button>
            ) : (
              <Button
                type="three"
                data-test="add-new-field-btn"
                className={`${
                  disableCreateAutomationBtn
                    ? "create-trigger-btn-disabled"
                    : "create-trigger-btn"
                }`}
                // disabled={disableCreateAutomationBtn}
                onClick={
                  disableCreateAutomationBtn
                    ? () => _showToasterMsg("Map atleast one field to proceed")
                    : () => _createTriggerPopup()
                }>
                <FontAwesomeIcon icon={["fas", "plus"]} className="" />
                &nbsp; Create an automation
              </Button>
            )}
          </div>
        </div>
      )}
      {dataSourceSelected !== "csv" &&
        triggerDetails &&
        triggerDetails[currentSelectedObject] &&
        triggerDetails[currentSelectedObject].trigger_id && (
          <div className="sf-mapper-trigger-container">
            <div className="trigger-automation-swith">
              <span className="assigned-sf-field-head">
                Automation details for {currObj.label}
              </span>
              <span
                onKeyPress={() => {}}
                role="button"
                tabIndex="0"
                onClick={() => handleShowTriggerDetails(!showTriggerDetails)}>
                <Input
                  data-test="input-revv-inp-checkbox-or-radio"
                  className=" docsharingpopup-sharingform-col"
                  isSwitch
                  type="checkbox"
                  onChange={() => {
                    _disableTrigger();
                  }}
                  value=""
                  checked={showActiveTriger}
                />
                <span
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0"
                  onClick={() => handleShowTriggerDetails(!showTriggerDetails)}>
                  <FontAwesomeIcon
                    icon={[
                      "far",
                      `${showTriggerDetails ? "angle-up" : "angle-down"}`,
                    ]}
                    className="showhide-automation-details"
                  />
                </span>
              </span>
            </div>
            {showTriggerDetails && (
              <div className="trigger-automation-link">
                Trigger Id
                <span className="trigger-automation-link-copy">
                  <Input
                    id="fillable-doc-link"
                    className="trigger-automation-link-inp"
                    value={triggerDetails[currentSelectedObject].trigger_id}
                    placeholder="Generating link..."
                    disabled
                  />
                  <Button
                    className="copy-btn revv-btn-secondary"
                    onClick={() =>
                      _onCopyBtnClick(
                        triggerDetails[currentSelectedObject].trigger_id,
                      )
                    }
                    data-test="quotation-draft-btns-copy"
                    disabled={
                      !triggerDetails[currentSelectedObject].trigger_id
                    }>
                    <FontAwesomeIcon icon={["far", "copy"]} className="" /> Copy
                  </Button>
                </span>
              </div>
            )}
            {showTriggerDetails && (
              <div className="trigger-automation-link">
                Salesforce package
                <span className="trigger-automation-link-copy">
                  <Input
                    id="fillable-doc-link"
                    className="trigger-automation-link-inp"
                    value={triggerPackageUrl}
                    placeholder="Generating link..."
                    disabled
                  />
                  <Button
                    className="copy-btn revv-btn-secondary"
                    onClick={() => {}}
                    data-test="quotation-draft-btns-copy"
                    disabled={!triggerPackageUrl}>
                    <a
                      href={`${triggerPackageUrl}`}
                      target="_blank"
                      rel="noreferrer"
                      data-test="trigger-package-url-link">
                      <FontAwesomeIcon
                        icon={["far", "arrow-pointer"]}
                        className=""
                      />{" "}
                      Click
                    </a>
                  </Button>
                </span>
              </div>
            )}
          </div>
        )}
      {dataSourceSelected !== "csv" && (
        <div className="sf-mapper-left-container">
          {currentSelectedObject &&
            sourceObjSchema &&
            sourceObjSchema[currentSelectedObject] && (
              <Fragment>
                <FieldsPool
                  searchInput={searchInput}
                  filterState={filterState}
                  currentObject={currObj}
                  currentDataSource={dataSource}
                  showMenuType={showMenuType}
                  searchRelatedObjects={_searchRelatedObjects}
                />
              </Fragment>
            )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({
  FieldsSettingStore: {
    dsObjects,
    dataSourceSelected,
    currentSelectedObject,
    objectFieldsMapping,
    sourceObjSchema,
    syncDataSource,
    csvData,
    triggerDetails,
    triggerPackageUrl,
  },
}) => ({
  dsObjects,
  sourceObjSchema,
  dataSourceSelected,
  objectFieldsMapping,
  currentSelectedObject,
  syncDataSource,
  csvData,
  triggerDetails,
  triggerPackageUrl,
});

const mapDispatchToProps = {
  updateCurrObj: updateCurrentSelectedObject,
  nukeDataSource: nukeSyncDataSourceFlags,
  updateCSVData: setCSVData,
  nukeCSV: nukeCSVData,
  updateTrigger: updateTriggerAction,
  getTriggers: getTriggerDetailsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsMapper);
